import { ButtonsListContainer } from 'components/Button';
import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { CustomCheckBox } from 'components/input';
import React from 'react';
import { IStyle } from 'Styles/styleModel';
import { generateCrystalColorHex } from 'utils/ExperimentUtils';
import { CrystalProps } from './CrystalCard';
import { useOnCrystalCheckHandler, useUnAssignCrystal } from './hooks';
import { useSelectedTripId } from 'redux/hooks/synchrotron';

const CrystalCardHeader = (props: CrystalProps) => {
  const { crystal, openCrystal } = props;
  const selectedTripId = useSelectedTripId();
  const onCrystalChecked = useOnCrystalCheckHandler();
  const unAssignCrystal = useUnAssignCrystal(crystal.id);
  const circleColor = generateCrystalColorHex(crystal.id);
  const toolButtons: RMCustomButtonProps[] = [
    {
      Icon: <RMSvgIcon name="CrystalDefinition" height={20} width={20} fill="white" />,
      titleTip: 'Crystal Definition',
      isDisabled: false,
      onClick: () => openCrystal(crystal.id),
      showBorder: true,
      customStyle: { ...styles.toolsButton, backgroundColor: 'rgb(0, 106, 245)' },
      buttonMainContainerStyle: styles.toolsContent,
    },
    {
      Icon: <RMSvgIcon name="UnassignCrystal" height={20} width={20} />,
      titleTip: 'Unassign Crystal',
      isDisabled: !crystal.isChecked || !selectedTripId,
      onClick: unAssignCrystal,
      showBorder: true,
      customStyle: crystal.isChecked
        ? { ...styles.toolsButton, backgroundColor: '#EB3324' }
        : styles.toolsButton,
      buttonMainContainerStyle: styles.toolsContent,
    },
  ];

  const onCrystalCheckBoxCLick = (event) => {
    onCrystalChecked(crystal);
  };

  return (
    <>
      <div id={'exp-crsytalcardheader-container'} style={styles.header}>
        <div id={'exp-crsytalcardheader-content'} style={{ ...styles.circle, backgroundColor: circleColor }}></div>
        <CustomCheckBox
          id={`exp-crsytalcardheader-checkbox-${crystal.name}`}
          label={crystal.name}
          onClick={onCrystalCheckBoxCLick}
          checked={crystal.isChecked}
          labelStyle={styles.labelStyle}
        />
      </div>
      <div id={'exp-crsytalcardheader-buttons'} style={styles.toolsContainer}>
        <ButtonsListContainer
          containerStyleClass="align-items-center"
          buttonsList={toolButtons}
        />
      </div>
    </>
  );
};
const styles: IStyle = {
  header: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
  },
  circle: {
    marginInline: '1%',
    height: '2.4vh',
    width: '2.4vh',
    borderRadius: '50%',
    display: 'inline-block',
  },
  toolsContainer: {
    display: 'flex',
    paddingBlock: '1%',
    paddingInline: '2%',
    alignItems: 'center',
    justifyContent: 'end',
  },
  toolsButton: {
    paddingLeft: '5%',
    outline: '2px solid #CCC',
    border: '1px solid #999 !important',
    borderRadius: '5px',
    paddingTop: '2%',
    margin: '1%',
    paddingBottom: '1%',
    height: '3vh',
    width: '1.5vw',
  },
  toolsContent: {
    paddingInline: '5%',
  },
  labelStyle: {
    fontSize: 15,
    marginLeft: '0.5rem',
  },
};
export default CrystalCardHeader;
